import React from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import EmptyFood from './../../Icons/EmptyFood';
import { useTranslation } from 'react-i18next';
import { InfoIconToolTip } from '../../UI/InfoIconToolTip/InfoIconToolTip';
interface IProps {
    name: string;
    category: string;
    photoUrl?: string;
    revenue: string;
    total: string;
    label?: string;
    allVenues?: boolean;
}

const useStyles = makeStyles({
    itemCard: {
        borderBottom: '1px solid #E8EAF4',
        '@media only screen and max-width(600px)': {
            width: '100%',
        },
        '@media only screen and max-width(1200px)': {
            backgroundColor: '#FFFFFF',
            borderRadius: '16px',
        },
    },
    itemHeader: {
        padding: '14px 0',
        display: 'flex',
        '@media only screen and max-width(1200px)': {
            minHeight: '80px',
        },
    },
    cardPhoto: {
        flex: '0 0 55px',
        backgroundPosition: 'center',
        borderRadius: '12px',
        height: '55px',
        width: '55px',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        overflow: 'hidden',
        '@media only screen and max-width(600px)': {
            transform: 'translate(12px)',
        },
        '@media only screen and max-width(1200px)': {
            transform: 'translate(12px)',
        },
    },
    itemDetails: {
        flex: '1 1 auto',
    },
    cardName: {
        paddingLeft: '22px',
        fontSize: '17px',
        lineHeight: '30px',
        color: '#212121',
    },
    cardCategory: {
        paddingLeft: '22px',
        fontSize: '14px',
        color: '#616161',
    },
    cardTotals: {
        width: '100%',
        display: 'flex',
        paddingBottom: '20px',
    },
    cardTotal: {
        flex: '1 1 50%',
        position: 'relative',
        textAlign: 'center',
    },
    cardTotalTitle: {
        display: 'flex',
        color: '#8D98B7',
        fontSize: '13px',
        lineHeight: '25px',
        alignItems: 'center',
        justifyContent: 'center',
        '&>svg': {
            marginLeft: '0.3125rem',
        },
    },
    cardTotalValue: {
        color: '#212121',
        fontSize: '17px',
        fontWeight: 600,
    },
});

const ItemCard = (props: IProps) => {
    const Styles = useStyles();
    const { t } = useTranslation();
    return (
        <div className={Styles.itemCard}>
            <div className={Styles.itemHeader}>
                {props.photoUrl ? (
                    <div className={Styles.cardPhoto} style={{ backgroundImage: `url(${props.photoUrl})` }}></div>
                ) : (
                    <div className={Styles.cardPhoto}>
                        <EmptyFood />
                    </div>
                )}

                <div className={Styles.itemDetails}>
                    <div className={Styles.cardName}>{props.name}</div>
                    <div className={Styles.cardCategory}>{props.category}</div>
                </div>
            </div>
            <div className={Styles.cardTotals}>
                <div className={Styles.cardTotal}>
                    <div className={Styles.cardTotalTitle}>
                        {t('misc.totalOrdered')}
                        {!props.label && !props.allVenues && (
                            <InfoIconToolTip infoMessage={'misc.Analytics.TopFiveTotalOrderedTooltip'} />
                        )}
                    </div>
                    <div className={Styles.cardTotalValue}>{props.total}</div>
                </div>
                <div className={Styles.cardTotal}>
                    <div className={Styles.cardTotalTitle}>
                        {props.label || 'Revenue'}
                        {!props.label && !props.allVenues && (
                            <InfoIconToolTip infoMessage={'misc.Analytics.TopFiveRevenueTooltip'} />
                        )}
                    </div>
                    <div className={Styles.cardTotalValue}>{props.revenue}</div>
                </div>
            </div>
        </div>
    );
};

export default ItemCard;
